export const environment = {
  production: true,
  stage: 'production',
  version: '0.0.1',
  title: 'InfluxTv',
  apiEndpoint: 'https://tv.influxhq.com/',
  fayeEndpoint: 'https://tv.influxhq.com/faye'
}
